import { render, staticRenderFns } from "./NewsflashAdmin.vue?vue&type=template&id=2a47a018&scoped=true&"
import script from "./NewsflashAdmin.vue?vue&type=script&lang=js&"
export * from "./NewsflashAdmin.vue?vue&type=script&lang=js&"
import style0 from "./NewsflashAdmin.vue?vue&type=style&index=0&id=2a47a018&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a47a018",
  null
  
)

export default component.exports